module.exports = __webpack_public_path__ + "img/unternehmen.551d0f7.jpg";